// extracted by mini-css-extract-plugin
export default {"banners__wrapper":"BannersPage_banners__wrapper__re04V"};